if (!customElements.get('stock-status-timer')) {
  customElements.define(
    'stock-status-timer',
    class StockStatusTimer extends HTMLElement {
      connectedCallback() {
        try {
          const cutoff = (this.dataset.cutoff || '').match(/^(\d{1,2}):(\d{2})$/);
          if (!cutoff) return;
          this.cutoffMinutes = parseInt(cutoff[1], 10) * 60 + parseInt(cutoff[2], 10);
          this.noShipDates = (this.dataset.noShip || '').split(/[\s,;]+/).filter(Boolean);
          this.textElement = this.querySelector('.stock-status__timer-text') || this;
          this.render();
          this.interval = setInterval(this.render.bind(this), 60 * 1000);
        } catch (error) {
          // Keep the static Liquid line if anything fails (e.g. no Intl support).
        }
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      // Current date and time in Europe/Berlin, independent of the device
      // timezone. The date is anchored at 12:00 UTC so day arithmetic is
      // immune to DST transitions.
      berlinNow() {
        const parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Europe/Berlin',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
        }).formatToParts(new Date());
        const value = (type) => parts.find((part) => part.type === type).value;
        return {
          date: new Date(Date.UTC(+value('year'), +value('month') - 1, +value('day'), 12)),
          minutes: +value('hour') * 60 + +value('minute'),
        };
      }

      isShippingDay(date) {
        const weekday = date.getUTCDay();
        if (weekday === 0 || weekday === 6) return false;
        return !this.noShipDates.includes(date.toISOString().slice(0, 10));
      }

      render() {
        const now = this.berlinNow();

        if (this.isShippingDay(now.date) && now.minutes < this.cutoffMinutes) {
          const remaining = this.cutoffMinutes - now.minutes;
          const hours = Math.floor(remaining / 60);
          const minutes = remaining % 60;
          const countdown = hours > 0 ? `${hours} Std. ${minutes} Min.` : `${minutes} Min.`;
          this.textElement.textContent = `Bestelle innerhalb von ${countdown} für Versand heute`;
          return;
        }

        const dayInMs = 24 * 60 * 60 * 1000;
        let nextDay = new Date(now.date.getTime() + dayInMs);
        for (let i = 0; i < 365 && !this.isShippingDay(nextDay); i++) {
          nextDay = new Date(nextDay.getTime() + dayInMs);
        }

        if (nextDay.getTime() - now.date.getTime() === dayInMs) {
          this.textElement.textContent = 'Versand morgen';
          return;
        }

        const weekday = new Intl.DateTimeFormat('de-DE', { weekday: 'long', timeZone: 'UTC' }).format(nextDay);
        const day = String(nextDay.getUTCDate()).padStart(2, '0');
        const month = String(nextDay.getUTCMonth() + 1).padStart(2, '0');
        this.textElement.textContent = `Versand am ${weekday}, ${day}.${month}.`;
      }
    }
  );
}
